import Link, { type LinkProps } from './Link';

export default Link;
export type { LinkProps };
